import React from "react";
import { Link } from "react-router-dom";
import { Plane, ShieldCheck, FileCheck2, CheckCircle2 } from "lucide-react";

const COUNTRIES = [
  { name: "Canada", img: "https://images.unsplash.com/photo-1774600787193-8310b7571c73?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwc3R1ZHklMjBhYnJvYWR8ZW58MHx8fHwxNzc4NTczNTc5fDA&ixlib=rb-4.1.0&q=85", tag: "PR-friendly · Affordable" },
  { name: "Germany", img: "https://images.unsplash.com/photo-1763567798715-a8e82b567ea4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwc3R1ZHklMjBhYnJvYWR8ZW58MHx8fHwxNzc4NTczNTc5fDA&ixlib=rb-4.1.0&q=85", tag: "Free education · Top engg" },
  { name: "United Kingdom", img: "https://images.unsplash.com/photo-1670552509890-6c784a03e2b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxoYXBweSUyMHN0dWRlbnQlMjBsYXB0b3AlMjBtb2Rlcm4lMjBjYWZlfGVufDB8fHx8MTc3ODU3MzU3OXww&ixlib=rb-4.1.0&q=85", tag: "Russell Group · 1-yr MS" },
  { name: "Australia", img: "https://images.unsplash.com/photo-1673515326564-9fb3e0f769da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxoYXBweSUyMHN0dWRlbnQlMjBsYXB0b3AlMjBtb2Rlcm4lMjBjYWZlfGVufDB8fHx8MTc3ODU3MzU3OXww&ixlib=rb-4.1.0&q=85", tag: "Post-study work · Sunshine" },
];

export default function StudyAbroad() {
  return (
    <main className="pt-28 pb-24">
      <section className="ali-hero-gradient pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10">
          <div className="ali-chip"><Plane className="w-3.5 h-3.5" /> Study Abroad</div>
          <h1 className="mt-4 font-satoshi font-black text-4xl sm:text-6xl text-[#0A192F] tracking-tight max-w-3xl">Your international degree.<br /><span className="ali-text-gradient">End-to-end support.</span></h1>
          <p className="mt-5 text-lg text-slate-600 font-inter max-w-2xl">Shortlisting, SOP, scholarships, visa, accommodation, pre-departure — we hold your hand from dream to runway.</p>
          <Link to="/demo" className="mt-7 inline-block ali-btn-primary">Talk to a Counsellor</Link>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-satoshi font-black text-3xl text-[#0A192F]">Top Destinations</h2>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {COUNTRIES.map(c => (
            <div key={c.name} className="ali-card overflow-hidden group cursor-pointer" data-testid={`country-${c.name}`}>
              <div className="h-44 overflow-hidden"><img src={c.img} alt={c.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
              <div className="p-5">
                <p className="font-satoshi font-bold text-lg text-[#0A192F]">{c.name}</p>
                <p className="text-xs text-[#FF6B35] font-poppins font-semibold mt-1">{c.tag}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-satoshi font-black text-3xl text-[#0A192F]">How we help</h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { i: FileCheck2, t: "Application Mastery", d: "SOPs, LORs, essays that admission officers love." },
            { i: ShieldCheck, t: "Visa Confidence", d: "Mock interviews, document checklists, embassy prep." },
            { i: Plane, t: "Pre-departure", d: "Flights, forex, housing, SIM, banking — all sorted." },
          ].map((c, i) => (
            <div key={i} className="ali-card p-8">
              <div className="w-12 h-12 rounded-2xl bg-[#FF6B35]/10 text-[#FF6B35] grid place-items-center mb-4"><c.i className="w-5 h-5" /></div>
              <h3 className="font-satoshi font-bold text-xl text-[#0A192F]">{c.t}</h3>
              <p className="mt-2 text-slate-500 font-inter">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
